import React from 'react';
import PropTypes, { any } from 'prop-types';
import { CheckBox, Select } from '../../Form';
import { required } from '../../../utils/validation';
import { allowedMatchTimes } from '../../../utils/allottedTimeConstants';
import { getDefaultAllottedTimeForScoringType } from '../../../utils/events';

const ScoringTypeAllottedTimeField = (props) => {
    const {
        formApi,
        values,
        scoringFormatOverride,
        scoringTypeOptions,
        eventAllottedMatchTimes,
        disableAllottedTimesField,
    } = props;

    const onCheckChange = (check) => {
        if (!check) {
            formApi.reset(scoringFormatOverride.id);
        }
    };

    const onChangeScoringType = (scoringTypeId) => {
        if (!disableAllottedTimesField) {
            const allottedTime = getDefaultAllottedTimeForScoringType(scoringTypeId, eventAllottedMatchTimes, scoringTypeOptions);
            formApi.setValue([scoringFormatOverride.id, 'allottedMatchTime'], allottedTime);
        }
    };

    const validateAllottedTimeField = (value) => {
        if (!disableAllottedTimesField) {
            return required(value);
        }

        return null;
    };

    const shouldDisplayAllottedTimes = values[scoringFormatOverride.id]?.override;

    return (
        <div>
            <CheckBox
                id={scoringFormatOverride.id}
                customLabel={`Override ${scoringFormatOverride.name} scoring`}
                field={[scoringFormatOverride.id, 'override']}
                formGroupCssClass={shouldDisplayAllottedTimes ? '' : `mb0`}
                onChange={onCheckChange}
            />
            {shouldDisplayAllottedTimes && (
                <div className="d-flex align-items-start">
                    <div className="flex-1">
                        <Select
                            id={`${scoringFormatOverride.id}scoringTypeId`}
                            label="Default scoring format"
                            field={[scoringFormatOverride.id, 'scoringTypeId']}
                            options={scoringTypeOptions}
                            themeV3
                            formGroupCssClass={`mb0`}
                            validate={required}
                            onChange={onChangeScoringType}
                        />
                    </div>
                    <div className="flex-1 ml16">
                        <Select
                            id={`${scoringFormatOverride.id}allottedMatchTime`}
                            field={[scoringFormatOverride.id, 'allottedMatchTime']}
                            label="Default allotted time"
                            options={allowedMatchTimes}
                            themeV3
                            formGroupCssClass={`mb0`}
                            validate={validateAllottedTimeField}
                            disabled={disableAllottedTimesField}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

ScoringTypeAllottedTimeField.propTypes = {
    formApi: PropTypes.objectOf(any).isRequired,
    values: PropTypes.objectOf(any).isRequired,
    scoringFormatOverride: PropTypes.objectOf(any).isRequired,
    scoringTypeOptions: PropTypes.arrayOf(any).isRequired,
    eventAllottedMatchTimes: PropTypes.arrayOf(any),
    disableAllottedTimesField: PropTypes.bool,
};

ScoringTypeAllottedTimeField.defaultProps = {
    eventAllottedMatchTimes: [],
    disableAllottedTimesField: false,
};

export default ScoringTypeAllottedTimeField;
